import UPLOAD_TYPE from './UPLOAD_TYPE';

// Builds the File type Select options, gated by the caller's upload permissions —
// a user is only offered the types they're allowed to upload.
export default function buildTypeOptions({ canUploadPlaybook, canUploadConnection }) {
  const options = [];
  if (canUploadPlaybook) {
    options.push({ value: UPLOAD_TYPE.PLAYBOOK, label: 'Playbook' });
  }
  if (canUploadConnection) {
    options.push({ value: UPLOAD_TYPE.CONNECTION, label: 'Connection' });
  }
  return options;
}
